import { CheckOutlined } from '@ant-design/icons';
import { Avatar, Empty, List, Space } from 'antd';
import React from 'react';
import { User } from '@/models/user';
import PosButton from '../PosButton';
import UserName from '../User/Name';
import { createStyles } from 'antd-style';

const useStyles = createStyles(({ css, token }) => {
  return {
    userListContainer: css`
      h2 {
        font-weight: normal;
        text-align: center;
        background: ${token.primary10};
        color: #fff;
        font-size: 14px;
        padding: 5px 0;
        margin-bottom: 0;
      }
    `,
  };
});

export type Props = {
  userList?: User[];
  queryMobile?: string;
  onSelect: (user: User) => void;
};

const MultiUserSelector: React.FC<Props> = ({ userList, queryMobile, onSelect }: Props) => {
  const { styles } = useStyles();
  if (!userList || !userList.length) {
    return (
      <div style={{ padding: '10% 0' }}>
        <Empty description={'没有找到匹配的用户'} />
      </div>
    );
  }

  return (
    <div className={styles.userListContainer}>
      <h2>
        【<b>{queryMobile}</b>】<br />
        与多个客户的手机号匹配
      </h2>
      <List
        footer={<div style={{ textAlign: 'center' }}>请点击【选择】进行确认</div>}
        size={'small'}
        itemLayout="horizontal"
        dataSource={userList}
        renderItem={item => (
          <List.Item
            actions={[
              <PosButton
                key={1}
                onClick={() => {
                  onSelect(item);
                }}>
                <CheckOutlined /> 选择
              </PosButton>,
            ]}>
            <List.Item.Meta
              title={`${item.mobile}`}
              description={
                <>
                  <Space direction={'horizontal'}>
                    <Avatar src={item.avatar} />
                    <UserName user={item} />
                  </Space>
                </>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default MultiUserSelector;
